import { SortOrder } from 'types/Search/form';

export const SortTranslationKeyMap: Record<SortOrder, string | undefined> = {
    [SortOrder.Airport]: undefined,
    [SortOrder.Departure]: undefined,
    [SortOrder.DistanceCityCenter]: 'TRANS-distance-city-center',
    [SortOrder.FlightDuration]: undefined,
    [SortOrder.LowestPrice]: 'TRANS-lowest-price',
    [SortOrder.Popularity]: 'TRANS-popularity',
    [SortOrder.Price]: 'TRANS-lowest-price',
    [SortOrder.Rating]: 'TRANS-best-guest-rating',
    [SortOrder.Region]: 'TRANS-regions-a-z',
    [SortOrder.TopRegion]: 'TRANS-top-regions',
    [SortOrder.TravelDuration]: 'TRANS-shortest-flight-duration',
    [SortOrder.PersonalPopularityIndex]: undefined,
};
export const SortTooltipTranslationKeyMap: Record<
    SortOrder,
    string | undefined
> = {
    [SortOrder.Airport]: undefined,
    [SortOrder.Departure]: undefined,
    [SortOrder.DistanceCityCenter]: undefined,
    [SortOrder.FlightDuration]: undefined,
    [SortOrder.LowestPrice]: undefined,
    [SortOrder.Popularity]: 'TRANS-popularity-sort-based-on-customer-reviews',
    [SortOrder.Price]: undefined,
    [SortOrder.Rating]: 'TRANS-sorting-by-guest-rating-hint',
    [SortOrder.Region]: undefined,
    [SortOrder.TopRegion]: undefined,
    [SortOrder.TravelDuration]: undefined,
    [SortOrder.PersonalPopularityIndex]: undefined,
};

export interface SortOption {
    value: SortOrder;
    label: string;
    tooltip?: string;
}
